module.exports = __webpack_public_path__ + "static/download-e5bd119734bf97007b2237f9934c151d.gif";